export const NavigationFooter = ({
  step,
  steps,
  onBack,
  onContinue,
  isContinueDisabled,
  totalPlannedAmount,
  balanceAmount,
}) => {
  return (
    <div className="flex justify-between gap-2 my-2">
      {step === 3 && (
        <div className="flex gap-4">
          {/* Total Planned Amount */}
          <div className="bg-green-100 text-green-800 px-4 py-2 rounded-full font-semibold shadow-sm">
            Total Planned Amount ={" "}
            <span className="font-bold">
              INR {totalPlannedAmount.toLocaleString("en-IN")}
            </span>
          </div>

          {/* Balance Amount */}
          <div
            className={`px-4 py-2 rounded-full font-semibold shadow-sm ${
              balanceAmount < 0
                ? "bg-red-100 text-red-600"
                : "bg-blue-100 text-blue-700"
            }`}
          >
            Balance Amount ={" "}
            <span className="font-bold">
              INR {balanceAmount.toLocaleString("en-IN")}
            </span>
          </div>
        </div>
      )}

      <div className="flex justify-end gap-2 flex-1">
        {step > 1 && (
          <button
            onClick={onBack}
            className="font-altis text-[16px] bg-white text-[#572575] border-2 border-[#572575] px-8 py-1 rounded-lg hover:bg-[#572575] hover:text-white"
          >
            Back
          </button>
        )}
        <button
          onClick={onContinue}
          disabled={step >= steps.length}
          className={`font-altis text-[16px] px-8 py-1 rounded-lg border-2 
          ${
            isContinueDisabled()
              ? "bg-gray-300 text-gray-500 border-gray-300 cursor-not-allowed"
              : "bg-white text-[#572575] border-[#572575] hover:bg-[#572575] hover:text-white"
          }`}
        >
          {step < steps.length ? "Continue" : "Done"}
        </button>
      </div>
    </div>
  );
};
